import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-submit-success-modal',
    templateUrl: './submit-success-modal.component.html',
    styleUrls: ['./submit-success-modal.component.scss'],
    standalone: false
})
export class SubmitSuccessModalComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
